// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3FWsk","list":"PatternAutocomplete_list__3ftI1"};